import React from 'react';
import { Button, Modal } from 'antd';
import { useRemoveEmailQueueWatcher } from 'mutation/mail';

type Props = {
  userId: number,
};

export default function RemoveEmailWatcherButton(props: Props) {
  const { isLoading, mutateAsync } = useRemoveEmailQueueWatcher();
  return (
    <>
      <Button
        icon="delete"
        loading={isLoading}
        type="danger"
        onClick={() =>
          Modal.confirm({
            title: 'Do you want to remove this user from the list?',
            content:
              'This user will no longer receive notifications when email is stuck in the queue.',
            onOk: () => mutateAsync(props.userId),
          })
        }
      >
        Remove From List
      </Button>
    </>
  );
}
